export default __webpack_public_path__ + "static/media/tourist-msk.3cd36f82.png";